import FilterAccordeon from './FilterAccordeon';
export default FilterAccordeon;